import React from "react";
import { Link } from "react-router-dom";
import { makeGet } from "@culturehq/client";
import { Panel } from "@culturehq/components";

import { useFetch } from "app/hooks";
import { Trans } from "app/utils";

import ErrorPage from "components/ErrorPage";
import NotFound from "components/NotFound";
import DefaultPanel from "components/display/DefaultPanel";

import Endorsement, { useEndorsementReceiver } from "components/endorsements/Endorsement";
import styles from "components/endorsements/styles.module.scss";

const EndorsementCallout = ({ match }) => {
  const { endorsementId } = match.params;
  const { error, fetching, json: { endorsement } } = useFetch(
    () => makeGet(`/endorsements/${endorsementId}`),
    [endorsementId]
  );

  const receiver = useEndorsementReceiver(endorsement);

  if ((error && error.status === 404) || (!fetching && !endorsement)) {
    return <NotFound />;
  }

  if (error) {
    return <ErrorPage error={error} />;
  }

  if (fetching) {
    return <DefaultPanel className="max-width-900" />;
  }

  return (
    <div className="max-width-900">
      <Panel>
        <Panel.Body className={styles.panel}>
          <Endorsement endorsement={endorsement} />
        </Panel.Body>
      </Panel>
      {receiver && (
        <Link to={`/community/${receiver.id}/spotlights`}>
          <Trans>← View all of {receiver.name}&#39;s spotlights</Trans>
        </Link>
      )}
    </div>
  );
};

export default EndorsementCallout;
